import { graphql } from 'gatsby';
import { Anchor } from '@twilio-paste/anchor';
import { Box } from '@twilio-paste/box';
import { Button } from '@twilio-paste/button';
import { Card } from '@twilio-paste/card';
import { Heading } from '@twilio-paste/heading';
import { Text } from '@twilio-paste/text';
import { Paragraph } from '@twilio-paste/paragraph';
import Changelog from '@twilio-paste/card/CHANGELOG.md';
import Img from 'gatsby-image';
import { DoDont, Do, Dont } from "../../../../src/components/DoDont";
import { Callout, CalloutTitle, CalloutText } from "../../../../src/components/callout";
import { SidebarCategoryRoutes } from "../../../../src/constants";
import * as React from 'react';
export default {
  graphql,
  Anchor,
  Box,
  Button,
  Card,
  Heading,
  Text,
  Paragraph,
  Changelog,
  Img,
  DoDont,
  Do,
  Dont,
  Callout,
  CalloutTitle,
  CalloutText,
  SidebarCategoryRoutes,
  React
};